import styles from './ButtonRound.module.scss'
import React from 'react'
import ArrowLineIcon from '@/assets/svg/arrow-line.svg'
import classNames from 'classnames'

type Props = {
  onClick?: () => void,
  arrowDirection?: 'left' | 'right',
}

const ButtonRound = ({ onClick, arrowDirection = 'right' }: Props) => {

  const classes = classNames({
    [styles.component]: true,
    [styles.left]: arrowDirection === 'left',
    [styles.right]: arrowDirection === 'right',
  })

  return (
    <button className={classes} onClick={onClick}>
      <ArrowLineIcon />
    </button>
  )
}

export default ButtonRound
